import React, { useCallback, useEffect } from 'react'
import RadioButton from '@ublique/components/RadioButton'
import { isEmpty } from 'lodash'

const RadioGroup = ({
  t,
  id,
  label,
  value,
  option,
  hidden,
  invalid,
  disabled,
  setValue,
  invalidText
}) => {
  // Auto selection of first element if not specified
  useEffect(() => {
    if (isEmpty(value) && option.length > 0) {
      setValue(id, option[0])
    }
  }, [])

  // Id generator function
  const getId = useCallback(
    (prefix, opt) =>
      `${prefix}-${label.replaceAll(' ', '-')}-${opt}`.toLowerCase(),
    [label]
  )

  if (hidden) {
    return null
  }

  return (
    <RadioButton.Form legendText={t(label)}>
      <RadioButton.ButtonGroup
        name={id}
        legend={t(label)}
        valueSelected={value?.value ?? ''}
        labelPosition='right'
        orientation='vertical'
        onChange={(value) => {
          const { label } = option.find((el) => el.value === value)
          setValue(id, { value, label })
        }}
      >
        {option.map(({ label, value }) => (
          <RadioButton
            value={value}
            labelText={t(label)}
            key={`key-${label}-${value}`}
            disabled={disabled}
            id={getId('id', value)}
          />
        ))}
      </RadioButton.ButtonGroup>
      {invalid && <span className='bx--form-requirement'>{invalidText}</span>}
    </RadioButton.Form>
  )
}

export default RadioGroup
